import cn from 'classnames';
import moment from 'moment';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import ImageViewer from 'react-simple-image-viewer';
import chzn_icon from '../../../../../assets/media/chzn.png';
import chz_active_icon from '../../../../../assets/media/chzn_atcive.png';
import { MODES_CONTENT_TABLE, TO_PROVIDER_PRODUCT } from '../../../../../constans';
import WbCategorySelect from '../../../../../pages/Providers/ContentWork/WbCategorySelect';
import { calcDaysAfterUpdate, formFullDate, getKvantWb, numberWithSpaces } from '../../../../../utils';
import { Column, Row } from '../../../../Basic/Blocks';
import { Button, CheckButton } from '../../../../Basic/Buttons';
import { Icon } from '../../../../Basic/Elements';
import { Input } from '../../../../Basic/Inputs';
import { TableCell, TableLine } from '../../../../Basic/Table';
import { Text, TextGrey } from '../../../../Basic/WrapsStyle';
import MarketsPairs from '../../../../Common/Elements/MarketsPairs';
import BarcodesBlock from '../../../../Common/Input/Barcodes';
import PackagingMethodSelect from '../../../Inputs/PackagingMethodSelect';
import ProductUnitSelect from '../../../Inputs/ProductUnitSelect';
import ProductContentStatus, { STATUSES_MAP } from '../../../WrapsStyle/ProductContentStatus';
import ProviderEditInput from '../EditInput';
import { WIDTH_CONTENT_TABLE } from '../Header';
import styles from '../styles.module.scss';

const ProductsTableLine = ({
  contentMode,
  providerId,
  isAdmin = true,
  isSmallProvider = true,
  isMinPackage = false,
  isCityStocks = false,
  product = {},
  productsSelect = {},
  changeProductSelect = (_) => _,
  onChange = (_) => _,
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const wb_kvant = getKvantWb(product.purchase, product.content_data.unit);
  const wb_name = `${product.wb_meta.name}${wb_kvant}`;

  let images =
    product.images.local?.length > 0
      ? product.images.local
      : product.images.foreign?.length > 0
        ? product.images.foreign
        : ['https://api.samsonopt.ru/goods/110983/b2fadb432e3ec30f0ccd03c3b2f624e1_x.jpg'];

  const openImageViewer = () => {
    setIsViewerOpen(true);
  };

  const closeImageViewer = () => {
    setIsViewerOpen(false);
  };

  const clickChange = async (field, value, action = undefined) => {
    await onChange(product.sku, field, value, action);
  };

  return (
    <>
      <TableLine key={`${product.sku}`} select={productsSelect[product.sku]} styles={styles.table_line}>
        <TableCell width={WIDTH_CONTENT_TABLE[10]} minWidth={WIDTH_CONTENT_TABLE[10]}>
          <CheckButton
            checked={productsSelect[product.sku]}
            //onSelect={() => console.log(product.artnumber)}

            onSelect={() => changeProductSelect(product.sku)}
          />
        </TableCell>

        <TableCell minWidth={WIDTH_CONTENT_TABLE[0]} width={WIDTH_CONTENT_TABLE[0]}>
          <Row spaceBetween>
            <div className={styles.wrapper}>
              {images.length > 0 && (
                <img onClick={() => openImageViewer()} className={styles.preview} src={images[0]} />
              )}
            </div>
          </Row>
        </TableCell>
        <TableCell minWidth={WIDTH_CONTENT_TABLE[1]} width={WIDTH_CONTENT_TABLE[1]}>
          <p className={styles.name_text}>{product.artnumber}</p>
          {(product.model || '').length > 0 && <TextGrey fontSize={12}>модель: {product.model}</TextGrey>}
          {contentMode === MODES_CONTENT_TABLE.STOCKS && <p className={styles.name_text}>{product.brand}</p>}
        </TableCell>
        {(product.provider_id === 29 || product.provider_id === 12 || product.provider_id === 6 || product.provider_id === 36 || product.provider_id === 46) && isAdmin && (
          <TableCell minWidth={WIDTH_CONTENT_TABLE[1]} width={WIDTH_CONTENT_TABLE[1]}>
            <Input value={product.sku_1c} onBlur={(v) => clickChange('sku_1c', v)} />
          </TableCell>
        )}

        {contentMode !== MODES_CONTENT_TABLE.STOCKS && (
          <TableCell minWidth={WIDTH_CONTENT_TABLE[1]} width={WIDTH_CONTENT_TABLE[1]}>
            <ProviderEditInput name={product.brand} onChange={(v) => clickChange('brand', v)} width={'150px'} />
          </TableCell>
        )}
        <TableCell minWidth={WIDTH_CONTENT_TABLE[2]} width={WIDTH_CONTENT_TABLE[2]}>
          {contentMode !== MODES_CONTENT_TABLE.CONTENT && (
            <>
              <Link to={TO_PROVIDER_PRODUCT(product.sku)} className={styles.link}>
                <p className={styles.name_text}>{product.name}</p>
              </Link>
              {/*     {product.url?.length > 0 ? (
                <a href={product.url} className={styles.name_text} target={'_blank'}>
                  <p className={styles.name_text}>{product.name}</p>
                </a>
              ) : (
                <p className={styles.name_text}>{product.name}1</p>
              )}*/}
              <TextGrey fontSize={12}>{product.category}</TextGrey>
            </>
          )}
          {contentMode === MODES_CONTENT_TABLE.CONTENT && (
            <Column>
              <ProviderEditInput name={product.name || ''} onChange={(v) => clickChange('name', v)} width={'370px'} />
              <ProviderEditInput
                name={product.category}
                onChange={(v) => clickChange('category', v)}
                width={'370px'}
                styleText={{ color: 'grey', fontSize: '12px' }}
              />
            </Column>
          )}
        </TableCell>

        {contentMode === MODES_CONTENT_TABLE.STOCKS && (
          <>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[3]} width={WIDTH_CONTENT_TABLE[3]} center>
              <Input
                value={product.stocks?.msk + product.stocks?.ekb}
                disabled={!isAdmin}
                center
                onBlur={(v) => clickChange('remains', v)}
              />
            </TableCell>
            {isCityStocks && (
              <>
                <TableCell minWidth={WIDTH_CONTENT_TABLE[3]} width={WIDTH_CONTENT_TABLE[3]} center>
                  <Input
                    value={product.stocks?.msk}
                    disabled={!isAdmin}
                    center
                    onBlur={(v) => clickChange('stocks_msk', v)}
                  />
                </TableCell>
                <TableCell minWidth={WIDTH_CONTENT_TABLE[3]} width={WIDTH_CONTENT_TABLE[3]} center>
                  <Input
                    value={product.stocks?.ekb}
                    disabled={!isAdmin}
                    center
                    onBlur={(v) => clickChange('stocks_ekb', v)}
                  />
                </TableCell>
              </>
            )}

            {isSmallProvider && (
              <>
                <TableCell minWidth={WIDTH_CONTENT_TABLE[3]} width={WIDTH_CONTENT_TABLE[3]} center>
                  <Input
                    value={product.quantity}
                    disabled={!isAdmin}
                    center
                    onBlur={(v) => clickChange('quantity', v)}
                  />
                </TableCell>
                <TableCell minWidth={WIDTH_CONTENT_TABLE[3]} width={WIDTH_CONTENT_TABLE[3]} center>
                  <Input value={product.min_opt} disabled={!isAdmin} center onBlur={(v) => clickChange('min_opt', v)} />
                </TableCell>
                <TableCell minWidth={WIDTH_CONTENT_TABLE[4]} width={WIDTH_CONTENT_TABLE[4]} center>
                  <Input value={product.cost} disabled={!isAdmin} center onBlur={(v) => clickChange('cost', v)} />
                </TableCell>
                <TableCell minWidth={WIDTH_CONTENT_TABLE[4]} width={WIDTH_CONTENT_TABLE[4]} center>
                  <Input value={product.course} disabled={!isAdmin} center onBlur={(v) => clickChange('course', v)} />
                </TableCell>
              </>
            )}

            <TableCell minWidth={WIDTH_CONTENT_TABLE[4]} width={WIDTH_CONTENT_TABLE[4]} center>
              <Text fontWeight={600}>{numberWithSpaces(product.purchase)}</Text>
            </TableCell>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[3]} width={WIDTH_CONTENT_TABLE[3]} center>
              <Text>{product.nds}</Text> %
            </TableCell>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[3]} width={WIDTH_CONTENT_TABLE[3]} center>
              <Text>{product.unit_1c}</Text>
            </TableCell>

            {isMinPackage && (
              <>
                <TableCell minWidth={WIDTH_CONTENT_TABLE[4]} width={WIDTH_CONTENT_TABLE[4]} center>
                  {product.min_kor} / {product.min_opt}
                </TableCell>
                <TableCell minWidth={WIDTH_CONTENT_TABLE[4]} width={WIDTH_CONTENT_TABLE[4]} center>
                  {product.ban_not_multiple ? 'Да' : 'Нет'}
                </TableCell>
              </>
            )}

            {isAdmin && (
              <>
                <TableCell minWidth={WIDTH_CONTENT_TABLE[9]} width={WIDTH_CONTENT_TABLE[9]} center>
                  <PackagingMethodSelect
                    method={product.packaging_method}
                    onSelect={(v) => clickChange('packaging_method', v.method)}
                  />
                </TableCell>
                <TableCell minWidth={WIDTH_CONTENT_TABLE[9]} width={WIDTH_CONTENT_TABLE[9]} center>
                  <BarcodesBlock
                    barcodes={product.barcodes}
                    onAdd={(b) => clickChange('barcodes', b, 'add')}
                    onRemove={(b) => clickChange('barcodes', b, 'pull')}
                  />
                </TableCell>
              </>
            )}
            <TableCell minWidth={WIDTH_CONTENT_TABLE[1]} width={WIDTH_CONTENT_TABLE[1]}>
              {product.created_at ? (
                <>
                  <Text>{formFullDate(product.created_at)}</Text>
                  <TextGrey fontSize={12}> {moment(product.created_at).fromNow()}</TextGrey>
                </>
              ) : (
                '-'
              )}
            </TableCell>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[1]} width={WIDTH_CONTENT_TABLE[1]}>
              {product.updated_at ? (
                <>
                  <Text>{formFullDate(product.updated_at)}</Text>
                  <TextGrey fontSize={12}> {moment(product.updated_at).fromNow()}</TextGrey>
                </>
              ) : (
                '-'
              )}
            </TableCell>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[3]} width={WIDTH_CONTENT_TABLE[3]} center>
              {calcDaysAfterUpdate(product.updated_at)}
            </TableCell>
          </>
        )}
        {contentMode === MODES_CONTENT_TABLE.CONTENT && (
          <>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[7]} width={WIDTH_CONTENT_TABLE[7]} center>
              <ProductContentStatus contentStatus={product.content_data.statuses.basic.status} />
            </TableCell>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[9]} width={WIDTH_CONTENT_TABLE[9]} center>
              <Row>
                <Input
                  value={product.content_data.sizes.width}
                  center
                  onBlur={(v) => clickChange('width', v)}
                  width={'50px'}
                  fontWeight={600}
                />
                <Text> x </Text>
                <Input
                  value={product.content_data.sizes.depth}
                  center
                  onBlur={(v) => clickChange('depth', v)}
                  width={'50px'}
                  fontWeight={600}
                />
                <Text> x </Text>
                <Input
                  value={product.content_data.sizes.height}
                  center
                  onBlur={(v) => clickChange('height', v)}
                  width={'50px'}
                  fontWeight={600}
                />
              </Row>
            </TableCell>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[9]} width={WIDTH_CONTENT_TABLE[9]} center>
              <Text fontSize={16}>
                {isAdmin ? (
                  <ProviderEditInput
                    name={product.content_data.min_volume}
                    onChange={(v) => clickChange('min_volume', v)}
                    width={'50px'}
                  />
                ) : (
                  product.minVolume
                )}
                {` л. < `}
                <span
                  style={
                    product.content_data.volume >= product.content_data.min_volume &&
                      product.content_data.volume <= product.content_data.max_volume
                      ? { color: 'green', fontWeight: 600 }
                      : { color: 'red', fontWeight: 600 }
                  }
                >
                  {product.content_data.volume}
                </span>
                {` л.  < `}
                {isAdmin ? (
                  <ProviderEditInput
                    name={product.content_data.max_volume}
                    onChange={(v) => clickChange('max_volume', v)}
                    width={'50px'}
                  />
                ) : (
                  product.content_data.max_volume
                )}
                {` л.`}
              </Text>
            </TableCell>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[4]} width={WIDTH_CONTENT_TABLE[4]} center>
              <Input
                value={product.content_data.weight}
                center
                onBlur={(v) => clickChange('weight', v)}
                width={'70px'}
                fontWeight={600}
              />
            </TableCell>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[9]} width={WIDTH_CONTENT_TABLE[9]} center>
              <Text fontSize={16}>
                {isAdmin ? (
                  <ProviderEditInput
                    name={product.content_data.min_weight}
                    onChange={(v) => clickChange('min_weight', v)}
                    width={'30px'}
                  />
                ) : (
                  product.content_data.min_weight
                )}
                {` кг. < `}{' '}
                <span
                  style={
                    product.content_data.weight >= product.content_data.min_weight &&
                      product.content_data.weight <= product.content_data.max_weight
                      ? { color: 'green', fontWeight: 600 }
                      : { color: 'red', fontWeight: 600 }
                  }
                >
                  {product.content_data.weight}{' '}
                </span>{' '}
                кг. {` < `}{' '}
                {isAdmin ? (
                  <ProviderEditInput
                    name={product.content_data.max_weight}
                    onChange={(v) => clickChange('max_weight', v)}
                    width={'30px'}
                  />
                ) : (
                  product.content_data.max_weight
                )}
                {` кг.`}
              </Text>
            </TableCell>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[11]} width={WIDTH_CONTENT_TABLE[11]} center>
              <Input value={product.term} center onBlur={(v) => clickChange('term', v)} width={'100px'} />
            </TableCell>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[7]} width={WIDTH_CONTENT_TABLE[7]} center>
              <ProductUnitSelect
                unit={product.content_data.unit}
                onSelect={(v) => clickChange('unit', v)}
                width={'140px'}
              />
            </TableCell>
          </>
        )}
        {contentMode === MODES_CONTENT_TABLE.WB && (
          <>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[2]} width={WIDTH_CONTENT_TABLE[2]}>
              <Column>
                <Row style={{ marginBottom: '4px', display: 'inline-block', minHeight: '30px' }}>
                  <ProviderEditInput
                    name={product.wb_meta.name || ''}
                    onChange={(v) => clickChange('wb_name', v)}
                    width={'300px'}
                    styleText={wb_name.length > 60 ? { color: 'red', fontWeight: 500 } : {}}
                  />
                  {wb_kvant}
                </Row>

                <TextGrey fontSize={12}>
                  {(product.wb_meta.name || '').length} + {wb_kvant.length} = {wb_name.length}
                </TextGrey>
              </Column>
            </TableCell>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[9]} width={WIDTH_CONTENT_TABLE[9]} center>
              <WbCategorySelect category={product.wb_meta.category} onChange={(v) => clickChange('wb_category', v)} />
            </TableCell>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[7]} width={WIDTH_CONTENT_TABLE[7]} center>
              <Input
                value={product.short_name}
                onBlur={(v) => clickChange('short_name', v)}
                width={'170px'}
                maxLength={28}
              />
            </TableCell>

            <TableCell minWidth={WIDTH_CONTENT_TABLE[7]} width={WIDTH_CONTENT_TABLE[7]} center>
              <ProductUnitSelect
                unit={product.content_data.unit}
                onSelect={(v) => clickChange('unit', v)}
                width={'140px'}
              />
            </TableCell>
            <TableCell minWidth={WIDTH_CONTENT_TABLE[7]} width={WIDTH_CONTENT_TABLE[7]} center>
              <div
                className={cn(
                  styles.status,
                  product.content_data.status === 'new' && styles.new,
                  product.content_data.status === 'default_good' && styles.default_good,
                  product.content_data.status === 'success' && styles.succes,
                  product.content_data.status === 'error' && styles.error,
                )}
              >
                {STATUSES_MAP[product.content_data.status]}
              </div>
            </TableCell>
          </>
        )}

        {isAdmin && (
          <TableCell width={WIDTH_CONTENT_TABLE[5]} minWidth={WIDTH_CONTENT_TABLE[5]} fontSize="14px" center>
            <Button onClick={() => clickChange('is_chzn', !product.is_chzn)}>
              <Icon src={product.is_chzn ? chz_active_icon : chzn_icon} width={'40px'} />
            </Button>
          </TableCell>
        )}
        <TableCell width={WIDTH_CONTENT_TABLE[9]} minWidth={WIDTH_CONTENT_TABLE[9]} fontSize="14px">
          <MarketsPairs market={product.market} width={'25px'} />
        </TableCell>
      </TableLine>
      {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
    </>
  );
};

export default ProductsTableLine;
